import { useEffect, useState } from "react";
import { User } from "@/api/user/userTypes";
import { userApi } from "@/api/user/userApi";

export default function useUser(userId?: string) {
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState<User | undefined>();

  const fetchUser = async () => {
    if (!userId) return;
    try {
      setIsLoading(true);
      const userResponse = await userApi.fetchUser(userId);
      setUser(userResponse);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, [userId]);

  return {
    isLoading,
    user,
  };
}
